import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import "../Home/Modul.css"
import Tab from 'react-bootstrap/Tab';
import {Col, Nav, Row} from "react-bootstrap";
import ChoiceButton from "../ChoiceRayon/ChoiceButton";
import Test0 from "../ListMain/Test0";

import Lottie from "lottie-react";
import groovyWalkAnimation from "../../Image/scanning-searching-for-data.json";
import {GiNotebook, ImSearch} from "react-icons/all";

export default function Home() {
    return (
        <div style={{paddingTop: 70}}>

            <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                <Row className="history" style={{
                    marginLeft: "0px"
                }}>
                    <Col className="historycol col-auto fluid col-sm-auto " md={3}>
                        <Nav variant="tabs" className="flex-column flex-row nav-justified">

                            <div
                                className="tabmain">
                                <Row>
                                    <Col md={4}><GiNotebook className="svgtitle" style={{
                                        color: "darkred", marginRight: "2%", marginLeft: "2%",

                                    }}/></Col>
                                    <Col md={8}> Довідник малого та середнього
                                        бізнесу</Col></Row>
                            </div>
                            <Nav.Item>
                                <hr/>
                                <Nav.Link className="flex-fill nav-justified" eventKey="1">
                                    <div style={{
                                        backgroundColor: "black",
                                        clipPath: "polygon(50% 0%, 0% 100%, 50% 100%)",
                                        width: "4rem",
                                        marginLeft: "1rem"
                                    }}>""
                                    </div>
                                    <div className="cart-company-lg_tab ">
                                        <Row>
                                            <Col md={4}><ImSearch className="svg" style={{
                                                color: "darkred", marginLeft: "20%"
                                            }}/></Col>
                                            <Col md={8} style={{
                                                paddingRight: "1rem"
                                            }}>У розрізі товарів та
                                                послуг</Col></Row>
                                    </div>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link className="flex-fill nav-justified" eventKey="2">
                                    <div style={{
                                        backgroundColor: "black",
                                        clipPath: "polygon(50% 0%, 0% 100%, 50% 100%)",
                                        width: "4rem",
                                        marginLeft: "1rem"
                                    }}>""
                                    </div>
                                    <div
                                        className="cart-company-lg_tab ">
                                        <Row>
                                            <Col md={4}><ImSearch className="svg" style={{
                                                color: "darkred", marginLeft: "20%"
                                            }}/> </Col>
                                            <Col md={8} style={{
                                                paddingRight: "1rem"
                                            }}>У розрізі районів</Col></Row>
                                    </div>
                                </Nav.Link>
                            </Nav.Item>
                            {/*<Nav.Item>
                                <Nav.Link className="flex-fill nav-justified" eventKey="3">У розрізі громад </Nav.Link>
                            </Nav.Item>*/}
                        </Nav>

                        <Lottie className="lottsearch" animationData={groovyWalkAnimation}/>;

                    </Col>

                    <Col md={9} col-sm-auto className="bodyselectkved" style={{justifyContent: "stretch"}}>
                        <Tab.Content>
                            <Tab.Pane eventKey="1">
                                <Test0/>
                            </Tab.Pane>
                            <Tab.Pane eventKey="2">
                                <ChoiceButton/>
                            </Tab.Pane>


                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    );
}